//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { ExitConfirmationModalAction } from '@catalog-ingestion/actions/exitConfirmationModalActions';
import { EXIT_CONFIRMATION_MODAL_ACTIONS } from '@catalog-ingestion/constants/exitConfirmationModalConstants';
import { IExitConfirmationModalState } from '@catalog-ingestion/models/ExitConfirmationModalModel';

const initialState: IExitConfirmationModalState = {
  isOpen: false,
};

export default function ExitConfirmationModalReducer(
  state: IExitConfirmationModalState = initialState,
  action: ExitConfirmationModalAction,
): IExitConfirmationModalState {
  switch ( action.type ) {
    case EXIT_CONFIRMATION_MODAL_ACTIONS.OPEN_MODAL:
      return {
        ...state,
        isOpen: true,
      };
    case EXIT_CONFIRMATION_MODAL_ACTIONS.CLOSE_MODAL:
      return {
        ...state,
        isOpen: false,
      };
    default:
      return state;
  }
}
